/**
 * Daten-Hooks für die Geräte-/Sitzungsübersicht (Phase W, Kapitel 3.5).
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../store/auth';
import { sessionsApi } from '../lib/sessions';

const SESSIONS_KEY = ['sessions'];

export function useSessions() {
  const token = useAuth((s) => s.token);
  return useQuery({
    queryKey: SESSIONS_KEY,
    queryFn: () => sessionsApi.list(token!),
    enabled: !!token,
  });
}

export function useRevokeOtherSessions() {
  const token = useAuth((s) => s.token);
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => sessionsApi.revokeOthers(token!),
    onSuccess: () => qc.invalidateQueries({ queryKey: SESSIONS_KEY }),
  });
}
